import { graphql } from "generated/gql";

export const TaxaListFieldsFragment = graphql(/* GraphQL */ `
  fragment TaxaListFields on Taxon {
    id
    scientificName
    authorship
    commonName
    fullyValidated
    nativeDistribution
    updatedBy {
      id
      initials
      email
      givenName
      familyName
      avatarUrl
      isActivated
      accessRole
      deactivatedAt
    }
    createdBy {
      id
      initials
      email
      givenName
      familyName
      avatarUrl
      isActivated
      accessRole
      deactivatedAt
    }
    sharedScientificName {
      id
      scientificName
      parentPrimaryRank {
        id
        scientificName
      }
      status
      nameSourceUrl
      nameSource
      rank
      authorship
      classification {
        family
      }
      taxon {
        nativeDistribution
        climate
        globalRedListStatus
        lifeForms {
          nodes {
            id
            name
          }
        }
      }
    }
    tagsConnection {
      nodes {
        id
        name
      }
    }
    notes
    updatedAt
  }
`);

export const getTaxaDocument = graphql(/* GraphQL */ `
  query GetTaxa(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $organisationSubdomain: String!
    $searchTerm: TaxaSearchTerm
    $orderBy: TaxaOrderByInput
    $filter: TaxaFilter
    $includeArchived: Boolean
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      total: taxaTotal(
        searchTerm: $searchTerm
        filter: $filter
        includeArchived: $includeArchived
      )
      result: taxa(
        before: $before
        after: $after
        first: $first
        last: $last
        searchTerm: $searchTerm
        orderBy: $orderBy
        filter: $filter
        includeArchived: $includeArchived
      ) {
        nodes {
          ...TaxaListFields
        }
        pageInfo {
          ...PageInfoFields
        }
      }
    }
  }
`);

export const getOrgLifeFormsDocument = graphql(/* GraphQL */ `
  query GetOrgLifeForms($organisationSubdomain: String!) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      lifeForms {
        nodes {
          id
          name
        }
        pageInfo {
          ...PageInfoFields
        }
      }
    }
  }
`);
export const getSiteLifeFormsDocument = graphql(/* GraphQL */ `
  query GetSiteLifeForms(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        lifeForms {
          nodes {
            id
            name
          }
          pageInfo {
            ...PageInfoFields
          }
        }
      }
    }
  }
`);

export const getOrgRedListStatusCountsDocument = graphql(/* GraphQL */ `
  query GetOrgRedListStatusCounts($organisationSubdomain: String!) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      redListStatusCounts {
        redListStatus
        count
      }
    }
  }
`);

export const getSiteRedListStatusCountsDocument = graphql(/* GraphQL */ `
  query GetSiteRedListStatusCounts(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        redListStatusCounts {
          redListStatus
          count
        }
      }
    }
  }
`);
